import { render, staticRenderFns } from "./Settings_Purposes.vue?vue&type=template&id=36fae3ed&scoped=true"
import script from "./Settings_Purposes.vue?vue&type=script&lang=js"
export * from "./Settings_Purposes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fae3ed",
  null
  
)

export default component.exports